import React from 'react';
import {
  BrowserRouter as Router,
  Route,
  Routes,
} from 'react-router-dom';
import Navbar from './components/Navbar';
import SignIn from './components/SignIn';
import SignUp from './components/SignUp';
import Home from './components/Home';
import Admin from './components/Admin';
import Job from './components/Job';
import Tutorial from './components/Tutorial';
import EmailVerified from './components/EmailVerified';
import { useAuth } from './AuthContext';
import { useNotifications } from './NotificationContext';
import AdminUserView from './components/AdminUserView';
import PasswordReset from './components/PasswordReset';
import RequestPasswordReset from './components/RequestPasswordReset';



// const Home = () => <div>Home Placeholder</div>;
// const Tutorial = () => <div>Tutorial Placeholder</div>;
// const Job = () => <div>Job Placeholder</div>;
// const Admin = () => <div>Admin Placeholder</div>;


const App = () => {
  const { loading } = useAuth(); 
  const { messages } = useNotifications();
  if (loading) {
    return <p></p>
  }
  return (
    <Router basename='/tapir'>
      <Navbar />
      <div id="notifications">
        {messages.map((message, i) => <div key={i} className={message.type + " message"}>{message.text}</div>)}
      </div>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/tutorial" element={<Tutorial />} />
        <Route path="/jobs/:id" element={<Job />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/signin" element={<SignIn />} />
        <Route path="/email_verified" element={<EmailVerified />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/users/:id" element={<AdminUserView></AdminUserView>}></Route>
        <Route path="/password_reset" element={<PasswordReset></PasswordReset>}></Route>
        <Route path="/request_password_reset" element={<RequestPasswordReset></RequestPasswordReset>}></Route>

      </Routes>
    </Router>
  );
}

export default App;